import { styles, variants, ProgressBarTheme } from '../ProgressBarStyles.css';
import { baseTheme } from './ProgressBarBaseTheme.css';
import { multiVariantStyles } from './ProgressBarVariants.css';
/*******************
 * Component Theme
 *******************/

const ProgressBarStableTheme: ProgressBarTheme = {
  baseTheme,
  multiVariantStyles,
  variants,
  styles
};

/*******************
 * Exports
 *******************/

export { ProgressBarStableTheme };
